import React from "react";
export default function Store() {
  return (
    <svg
      width="80"
      viewBox="0 0 158 115"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_398_127)">
        <path
          d="M3.92716 0.519287C3.41415 0.698372 2.68886 1.09236 2.33506 1.37891C1.52132 2.02361 0.60144 3.38467 0.35378 4.2622C0.24764 4.70992 0.17688 19.0727 0.17688 47.4938C0.17688 89.0957 0.17688 90.0986 0.51299 90.9761C1.04369 92.373 1.94588 93.3758 3.3257 94.0564L4.51093 94.6474L39.8379 94.7011C59.2792 94.719 75.1825 94.6832 75.1825 94.5936C75.1825 94.522 74.9172 94.3608 74.6164 94.2355C73.6612 93.8952 70.2647 91.9252 68.1949 90.5284C65.8245 88.9166 63.7724 87.269 61.7381 85.299L60.1814 83.8126H35.9284C12.0115 83.8126 11.6754 83.8126 11.3216 83.4544C11.127 83.2574 10.9324 82.9172 10.8793 82.7023C10.8263 82.4695 10.8086 66.4233 10.8263 47.0461L10.8793 11.7839L11.3039 11.4436C11.7108 11.1033 12.383 11.1033 37.8035 11.1033H63.8963L65.9483 9.52736C71.3084 5.44418 77.2699 2.56087 83.5853 0.984909C85.0535 0.608826 86.2741 0.286476 86.3095 0.250656C86.3449 0.214836 68.0357 0.179024 45.6225 0.179024C6.59835 0.19693 4.82935 0.19693 3.92716 0.519287Z"
          fill="white"
          fillOpacity="0.97"
        />
        <path
          d="M105.079 0.339947C105.22 0.429491 105.662 0.536943 106.052 0.608578C107.484 0.859299 111.252 2.02336 113.481 2.90089C119.744 5.4081 125.475 9.20474 130.269 14.0759C131.985 15.7951 133.188 17.192 135.541 20.2365L136.036 20.8633L135.983 12.7148L135.948 4.56639L135.488 3.56351C134.922 2.34572 134.037 1.41447 132.799 0.751846L131.879 0.268312L118.346 0.232496C110.792 0.196678 104.937 0.250404 105.079 0.339947Z"
          fill="white"
          fillOpacity="0.97"
        />
        <path
          d="M92.0057 3.24139C70.3708 4.9248 53.0347 21.7411 50.3104 43.6792C49.9035 46.9923 50.0451 53.5648 50.5758 56.6809C52.6632 68.823 58.7131 78.9235 68.2304 86.1766C74.6164 91.0298 82.1347 94.0564 90.219 95.0055C92.8018 95.31 97.9849 95.3637 100.444 95.0772C104.902 94.5936 110.049 93.1968 114.1 91.3522L116.135 90.4388L126.395 100.808C133.312 107.81 136.921 111.32 137.451 111.607C138.141 111.965 138.495 112.019 140.016 112.001C141.538 112.001 141.98 111.929 143.218 111.446C146.19 110.317 148.932 108.348 151.869 105.267C155.672 101.292 157.671 97.4769 157.671 94.1997C157.671 91.7641 158.095 92.2834 146.544 80.589L136.195 70.0946L136.974 68.4111C138.902 64.2205 140.229 59.4031 140.83 54.3528C141.148 51.774 141.095 46.0432 140.742 43.339C138.3 24.7676 125.351 9.65269 107.644 4.74571C102.62 3.34884 97.2242 2.82948 92.0057 3.24139ZM101.611 17.3534C105.521 18.1593 110.067 20.0577 113.234 22.2067C120.893 27.3823 125.988 35.6024 127.28 44.8254C127.775 48.3355 127.545 53.3678 126.731 56.6809C125.192 62.9311 122.291 68.035 117.709 72.5301C111.889 78.243 104.76 81.3054 96.5874 81.6098C81.6394 82.1471 68.1065 71.8496 64.4978 57.1645C63.7194 54.0125 63.5956 52.8843 63.5956 49.1593C63.6133 45.1119 63.8609 43.321 64.8516 39.99C68.195 28.815 77.0577 20.3263 88.1847 17.6579C91.1212 16.9594 92.271 16.852 96.1452 16.9057C98.9402 16.9594 100.09 17.049 101.611 17.3534Z"
          fill="white"
          fillOpacity="0.97"
        />
        <path
          d="M86.964 31.4834C82.2054 34.4025 78.3136 36.8739 78.3136 36.9814C78.3136 37.1425 95.4552 48.1564 95.7206 48.1743C95.9152 48.1743 113.428 37.1425 113.464 36.9993C113.481 36.8739 96.269 26.3794 95.7913 26.2361C95.7029 26.2003 91.7226 28.5643 86.964 31.4834Z"
          fill="white"
          fillOpacity="0.97"
        />
        <path
          d="M106.193 45.2728L97.3127 50.9498L97.295 61.0324C97.295 67.0676 97.3658 71.0971 97.4543 71.0613C97.5427 71.0255 101.594 68.4645 106.476 65.3663L115.321 59.7251L115.339 49.6425C115.339 44.1087 115.286 39.5778 115.215 39.5957C115.127 39.5957 111.076 42.1567 106.193 45.2728Z"
          fill="white"
          fillOpacity="0.97"
        />
        <path
          d="M76.067 49.75V59.7968L85.0005 65.438C89.936 68.5541 93.987 71.0972 94.0224 71.0972C94.0754 71.0972 94.1108 66.5663 94.1108 61.0146V50.9499L85.372 45.4519C80.578 42.4254 76.5093 39.8823 76.3501 39.8286C76.0847 39.7212 76.067 40.5808 76.067 49.75Z"
          fill="white"
          fillOpacity="0.97"
        />
        <path
          d="M16.4517 28.2059V36.1753H24.2353H32.0189V28.2059V20.2365H24.2353H16.4517V28.2059Z"
          fill="white"
          fillOpacity="0.97"
        />
        <path
          d="M35.7338 28.2059V36.1753H41.9783H48.2052L48.9659 33.7934C49.3728 32.504 50.0804 30.5878 50.5049 29.567L51.301 27.7224V23.9794V20.2365H43.5174H35.7338V28.2059Z"
          fill="white"
          fillOpacity="0.97"
        />
        <path
          d="M16.4517 47.4581V55.3379H24.2353H32.0189V47.4581V39.5782H24.2353H16.4517V47.4581Z"
          fill="white"
          fillOpacity="0.97"
        />
        <path
          d="M35.7338 47.4581V55.3379H41.3061H46.8785L46.7547 54.2992C46.6662 53.744 46.6132 51.3084 46.6132 48.8908C46.6308 44.8434 46.8608 42.0138 47.3561 39.9722L47.4446 39.5782H41.5892H35.7338V47.4581Z"
          fill="white"
          fillOpacity="0.97"
        />
        <path
          d="M16.4517 66.6202V74.5H24.2353H32.0189V66.6202V58.7403H24.2353H16.4517V66.6202Z"
          fill="white"
          fillOpacity="0.97"
        />
        <path
          d="M35.7338 66.6202V74.5H43.5351H51.3187L51.2656 72.3868C51.1949 70.3631 51.1595 70.2377 50.4519 68.6259C49.532 66.5664 48.4706 63.3787 47.8514 60.7461L47.3561 58.7403H41.5538H35.7338V66.6202Z"
          fill="white"
          fillOpacity="0.97"
        />
        <path
          d="M52.1324 98.802C51.018 100.36 49.9035 102.957 49.2666 105.518C49.1074 106.145 48.8952 106.951 48.8067 107.309L48.6298 107.989H43.1636H37.6797V111.481V114.974H68.0181H98.3564V111.481V107.989H92.9079H87.4594L87.1233 106.592C86.398 103.422 84.9828 100.02 83.8506 98.6229L83.3022 97.9603H68.0181H52.7516L52.1324 98.802Z"
          fill="white"
          fillOpacity="0.97"
        />
      </g>
      <defs>
        <clipPath id="clip0_398_127">
          <rect width="157.795" height="114.974" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
